import { redactSensitiveQueryParams } from "@jasperlabs/utils";

// Page fields Segment fills from window.location.
const PAGE_URL_FIELDS = ["url", "search", "referrer"];

type Payload = {
	properties?: Record<string, unknown>;
	options?: { context?: Record<string, unknown> };
};

function redact({ payload }: { payload: Payload }): void {
	const props = payload.properties;
	if (props) {
		for (const field of PAGE_URL_FIELDS) {
			const value = props[field];
			if (typeof value === "string") {
				props[field] = redactSensitiveQueryParams(value);
			}
		}
	}
	if (typeof window === "undefined") {
		return;
	}
	// Segment's analytics.js rebuilds context.page from window.location at send
	// time; only a caller-supplied context.page outranks it.
	payload.options = {
		...payload.options,
		context: {
			...payload.options?.context,
			page: {
				url: redactSensitiveQueryParams(window.location.href),
				search: redactSensitiveQueryParams(window.location.search),
				referrer: redactSensitiveQueryParams(document.referrer),
			},
		},
	};
}

// Register before the Segment plugin so it forwards the redacted payload.
export const redactSensitiveQueryParamsPlugin = {
	name: "redact-sensitive-query-params",
	page: redact,
	track: redact,
	identify: redact,
};
